<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "primary-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 16 18">
    <path
      d="M5.26228 5.60872V8.08564C5.26228 8.50195 4.77673 8.72937 4.45692 8.46286L0.42702 5.10461C0.191451 4.9083 0.191451 4.54649 0.42702 4.35018L4.45692 0.991937C4.77673 0.725425 5.26228 0.952845 5.26228 1.36915V3.84608H8.78756C10.6575 3.84608 12.4508 4.5889 13.7731 5.91114C15.0953 7.23337 15.8381 9.02671 15.8381 10.8966C15.8381 12.7666 15.0953 14.5599 13.7731 15.8821C12.4508 17.2044 10.6575 17.9472 8.78756 17.9472H6.0177C5.60049 17.9472 5.26228 17.609 5.26228 17.1918V16.94C5.26228 16.5228 5.60049 16.1845 6.0177 16.1845H8.78756C10.19 16.1845 11.535 15.6274 12.5267 14.6358C13.5184 13.6441 14.0755 12.2991 14.0755 10.8966C14.0755 9.49419 13.5184 8.14919 12.5267 7.15751C11.535 6.16584 10.19 5.60872 8.78756 5.60872H5.26228Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
